import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {BreakpointObserver} from '@angular/cdk/layout';
import {DatePipe} from '@angular/common';
import {Question} from '../../models/underwriter.model';
import {QuestionFlowSessionQuery} from '../state/question-flow-session.query';
import {GlobalQuestionService} from '../../services/global-question.service';
import {getParam} from '../question-helper';

declare const $: any;

const DEFAULT_YEAR_RANGE = 'c-10:c+10';

@Component({
  selector: 'app-question-date-picker',
  templateUrl: './question-date-picker.component.html',
  styleUrls: ['./question-date-picker.component.scss'],
  standalone: false
})
export class QuestionDatePickerComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() controlLabel: any;
  @Input() showControlLabel = false;
  @Input() numberMonths = 2;
  @Input() dateFormat = 'dd/MM/yyyy';//'yyyy-MM-dd';// ;
  @Input() jqueryPickerDateFormat = 'dd/mm/yy';//'yy/mm/dd'
  @Input() minDate: any;
  @Input() maxDate: any;
  @Input() firstDayOnly = false;
  @Input() changeYear = false;
  @Input() yearRange = DEFAULT_YEAR_RANGE;
  @Input() category: number;
  @Input() question: Question;
  @Input() initialDate = new Date();
  @Input() showOtherMonths = true;
  @Input() placeHolder = '';
  @Input() displayInline = false;
  @Input() showIcon = false;
  @Input() showLabel = false;
  @Input() addMarginBottom = false;
  @Input() showRelativeLabel = false;
  @Output() questionAnswer = new EventEmitter<any>();

  buttonImage = '';
  index = this.newGuid();
  pickerEl: any;
  pickerInlineEl: any;
  submittedDate = new Date();
  sessionDetails: any;
  parameters: any[] = [];
  skipped = false;
  showSkip = false;
  constructor(
    private observer: BreakpointObserver,
    private datePipe: DatePipe,
    private questionFlowSessionQuery: QuestionFlowSessionQuery,
    private globalQuestionService: GlobalQuestionService
  ) {
    this.sessionDetails = this.questionFlowSessionQuery.getValue();
  }

  ngOnInit(): void {
    this.observer.observe('(max-width: 768px)')
      .subscribe(o => {
        this.numberMonths = !o.matches ? this.numberMonths : 1;
      });
    if (this.question?.question_prompt && !this.showControlLabel) {
      this.controlLabel = this.question.question_prompt;
    }
    
  }
  onSkipChange(): void {
    if (this.skipped) {
      this.question.answer = 'skipped';
    } else {
      this.question.answer = '';
    }
    this.questionAnswer.emit(this.question);
  }
  ngAfterViewInit(): void {
    this.buttonImage = `assets/${this.sessionDetails?.category_id}/icn/calendar.svg`;
    if (this.displayInline) {
      this.numberMonths = 1;
      this.pickerInlineEl = document.getElementById(`picker-inline${this.index}`);
    }
    this.pickerEl = document.getElementById(`picker${this.index}`);
    this.initDatepicker();
  }

  ngOnChanges(changes: SimpleChanges): void {
   
    if (changes?.showControlLabel?.currentValue !== changes?.showControlLabel?.previousValue) {
      this.showControlLabel = changes?.showControlLabel?.currentValue;
    }

    if (changes?.controlLabel?.currentValue !== changes?.controlLabel?.previousValue) {
      this.controlLabel = changes?.controlLabel?.currentValue;
    }

    if (changes?.numberMonths?.currentValue !== changes?.numberMonths?.previousValue) {
      this.numberMonths = changes?.numberMonths?.currentValue;
    }

    if (changes?.dateFormat?.currentValue !== changes?.dateFormat?.previousValue) {
      this.dateFormat = changes?.dateFormat?.currentValue;
    }

    if (changes?.jqueryPickerDateFormat?.currentValue !== changes?.jqueryPickerDateFormat?.previousValue) {
      this.jqueryPickerDateFormat = changes?.jqueryPickerDateFormat?.currentValue;
    }

    if (changes?.minDate?.currentValue !== changes?.minDate?.previousValue) {
      this.minDate = changes?.minDate?.currentValue;
    }

    if (changes?.maxDate?.currentValue !== changes?.maxDate?.previousValue) {
      this.maxDate = changes?.maxDate?.currentValue;
    }

    if (changes?.changeYear?.currentValue !== changes?.changeYear?.previousValue) {
      this.changeYear = changes?.changeYear?.currentValue;
    }

    if (changes?.yearRange?.currentValue !== changes?.yearRange?.previousValue) {
      this.yearRange = changes?.yearRange?.currentValue || DEFAULT_YEAR_RANGE;
    }

    if (changes?.category?.currentValue !== changes?.category?.previousValue) {
      this.category = changes?.category?.currentValue;
      if (this.category) {
        this.buttonImage = `assets/${this.category}/icn/calendar.svg`;
      }
    }

    if (changes?.initialDate?.currentValue !== changes?.initialDate?.previousValue) {
      this.initialDate = changes?.initialDate?.currentValue;
      this.submittedDate = this.initialDate;
    }

    if (changes?.showOtherMonths?.currentValue !== changes?.showOtherMonths?.previousValue) {
      this.showOtherMonths = changes?.showOtherMonths?.currentValue;
    }

    if (changes?.question?.currentValue !== changes?.question?.previousValue) {
      this.question = changes?.question?.currentValue;
    }

    if (changes?.displayInline?.currentValue !== changes?.displayInline?.previousValue) {
      this.displayInline = changes?.displayInline?.currentValue;
    }
    if (this.question?.parameter) {
        this.parameters = JSON.parse(this.question?.parameter);
    }
    if (getParam(this.parameters, 'show_skip')?.value === '1') {
      this.showSkip = true;
    }
    this.initDatepicker();
    
  }

  setDateRanges(datePickerEl: any): void {
    this.globalQuestionService.getDateRanges()
      .subscribe((ranges: any[]) => {
        if (!ranges?.length) {
          this.generateDatepicker(datePickerEl);
          return;
        }

        const serializedRange = JSON.parse(ranges[0]?.date_range);
        const begin_date = serializedRange?.find(range => range.parameter === 'begin_date');
        const end_date = serializedRange?.find(range => range.parameter === 'end_date');

        const start_dateSplit = begin_date?.value.split('-');
        const start_year = start_dateSplit[0];
        const start_month = start_dateSplit[1];
        const start_day = start_dateSplit[2];
        this.minDate = new Date(+start_year, +start_month - 1, +start_day);

        const end_dateSplit = end_date?.value.split('-');
        const end_year = end_dateSplit[0];
        const end_month = end_dateSplit[1];
        const end_day = end_dateSplit[2];
        this.maxDate = new Date(+end_year, +end_month - 1, +end_day);

        this.generateDatepicker(datePickerEl);
      });
  }

  initDatepicker(): void {
    if (!this.pickerEl) { return; }
    const datePickerEl = this.displayInline ? this.pickerInlineEl : this.pickerEl;
    $(this.pickerEl).val(this.formatPickerValue(this.initialDate));
    $(datePickerEl).datepicker('destroy');
    this.submitValue();

    const modeParam = getParam(this.parameters, 'mode');
    const inclusiveParam = getParam(this.parameters, 'inclusive');
    if (modeParam) {
      if (modeParam.value === '1' || modeParam.value === 1) {
        this.generateDatepicker(datePickerEl);
      } else if (modeParam.value === '2' || modeParam.value === 2) {
        this.setDateRanges(datePickerEl);
      }
      else if (modeParam.value === '0' || modeParam.value === 0) {
        this.minDate = 0;
        this.generateDatepicker(datePickerEl);
      }
      else if (modeParam.value === '3' || modeParam.value === 3) {
        this.maxDate = new Date();
        this.generateDatepicker(datePickerEl);
      }
    } else if (inclusiveParam) {
        if (inclusiveParam.value === 'false' || inclusiveParam.value === false) {
          const startDate = new Date();
          const newStartDate = startDate.setDate(startDate.getDate() - 1);
          this.maxDate = new Date(newStartDate);
        }
    }
    else {
      this.generateDatepicker(datePickerEl);
    }
    
  }

  generateDatepicker(datePickerEl: any): void {
    $(datePickerEl).datepicker({
      dateFormat: this.jqueryPickerDateFormat,
      altFormat: this.dateFormat,
      numberOfMonths: this.numberMonths,
      showOn: 'both',
      beforeShowDay: (d) => {
        if (this.firstDayOnly){
          if( d.getDate() === 1 ){
            return [true, "",""];
          }
          return [false, "",""];
        }
        else{
          return [true,"",""];
        }

      },
      beforeShow: () => {

        // if number of months is greater than 1, we show the number of months based on the width of the input
        if (this.numberMonths > 1) {
          this.sizeMultiMonthDatePicker($(datePickerEl))
        }

      },
      onClose: () => {
          setTimeout(() => {     
              this.unsetSizeMultiMonthDatePicker($(datePickerEl));
          }, 250);
      },
      minDate: this.minDate != null ? (typeof this.minDate === 'number' ? this.minDate : new Date(this.minDate)) : null,
      maxDate: this.maxDate != null ? (typeof this.maxDate === 'number' ? this.maxDate : new Date(this.maxDate)) : null,
      defaultDate: this.initialDate != null ? new Date(this.initialDate) : null,
      buttonText: '',
      showOtherMonths: this.showOtherMonths,
      gotoCurrent: true,
      changeYear: this.changeYear,
      yearRange: this.yearRange || DEFAULT_YEAR_RANGE,
      showOptions: {
        direction: 'down'
      },
      constrainInput: true,
      onSelect: (i, d) => {
        const date = $(datePickerEl).datepicker('getDate');

        // This was creating a UX issue where the input would need to lose focus before the calendar would pop up again.       
        // $(this.pickerEl).datepicker('setDate', date);
        // $(this.pickerEl).val(this.formatPickerValue(date));

        // Instead we only update the input value if the calendar is displayed inline.
        if (this.displayInline) {
          $(this.pickerEl).val(this.datePipe.transform(date, this.dateFormat));
        }
        
        this.submittedDate = date;
        this.submitValue();
      }
    });
  }

  sizeMultiMonthDatePicker ($input): void {

      // get datepicker element
      const $inputWrapper = $input.closest(".input-wrap");
      const inputWidth = $inputWrapper ? $inputWrapper.outerWidth() : $input.outerWidth();
      if(!inputWidth) return;

      let numMonths = 1;
      if(inputWidth > 920){
          numMonths = 3;
      } else if(inputWidth > 600){
          numMonths = 2;
      }            
              
      $input.datepicker("option", "numberOfMonths", numMonths)  
      

      // match datepicker width to input width
      const $datepickerWidget = $input.datepicker("widget")
      $datepickerWidget.css("min-width", inputWidth)
  }

  unsetSizeMultiMonthDatePicker($input): void {
      $input.datepicker("widget").css("min-width", "revert-layer")
  }

  updateDatePicker(): void {
    const datePickerEl = this.displayInline ? this.pickerInlineEl : this.pickerEl;
    $(datePickerEl).datepicker('destroy');
    $(this.pickerEl).val(this.datePipe.transform(this.initialDate, this.dateFormat));
    this.submitValue();
    
    $(datePickerEl).datepicker({
      dateFormat: this.jqueryPickerDateFormat,
      altFormat: this.dateFormat,
      numberOfMonths: this.numberMonths,
      showOn: 'both',
      minDate: this.minDate ? this.minDate : null,
      maxDate: this.maxDate ? this.maxDate : null,
      defaultDate: this.initialDate,
      buttonText: '',
      showOtherMonths: this.showOtherMonths,
      changeYear: this.changeYear,
      yearRange: this.yearRange || DEFAULT_YEAR_RANGE,
      showOptions: {
        direction: 'down'
      },
      constrainInput: true,
      onSelect: (i, d) => {
        const date = $(datePickerEl).datepicker('getDate');
        $(this.pickerEl).datepicker('setDate', date);
        $(this.pickerEl).val(this.datePipe.transform(date, this.dateFormat));
        this.submittedDate = date;
        this.submitValue();
      }
    });
  }

    submitValue(): void {
    const date = this.datePipe.transform(this.submittedDate, 'yyyy-MM-dd');
    if (this.question) {
      this.question.answer = date;
      this.questionAnswer.emit(this.question);
    } else {
      this.questionAnswer.emit(date);
    }
  }

  openDatepicker(): void {
    $(`#picker${this.index}`).datepicker('show');
  }

  getRelativeDateLabel(date: Date): string {
    const rtf = new (Intl as any).RelativeTimeFormat('en', { numeric: 'auto' });
    const diffMs = new Date(date).setHours(0, 0, 0, 0) - new Date().setHours(0, 0, 0, 0);
    const dayDiff = Math.round(diffMs / (1000 * 60 * 60 * 24));
    const label = rtf.format(dayDiff, 'day');
    return label.charAt(0).toUpperCase() + label.slice(1);
  }

  formatPickerValue(date: Date): string {
    const formatted = this.datePipe.transform(date, this.dateFormat);
    return this.showRelativeLabel ? `${formatted} (${this.getRelativeDateLabel(date)})` : formatted;
  }

  newGuid(): any {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

}
